import { createSelector } from 'reselect'

const getArtistCaseStudies = state => state.artistCaseStudies

// Artist case studies are a list of collection, but only their first row
const getArtistCaseStudyItemColour = data => {
  if (!data) return null
  const acf = data.get('acf')
  const firstSlide = acf && acf.get('slide') && acf.get('slide').first()
  const collectionBackgroundColour = acf.get('background_colour')
  const collectionSpreadBackgroundColour = firstSlide && firstSlide.get('slide_background_colour')
  const colourResult = collectionSpreadBackgroundColour || collectionBackgroundColour

  return {
    id: data.get('id'),
    colour: colourResult
  }
}

export const getArtistCaseStudyColours = createSelector(
  [getArtistCaseStudies],
  casestudies => {
    const data = casestudies.get('data')
    const collections = data && data.get('collections')

    if (collections) {
      const baseColour = {
        id: 'base',
        colour: '#F3F1ED'
      }
      const colourList = collections.map(getArtistCaseStudyItemColour)

      // Get first colour and duplicate to start off artist page
      let firstColour = colourList.get(0)
      if (firstColour) {
        baseColour.id = parseInt(Math.random() * 9999, 10)
        baseColour.colour = firstColour.colour
      }

      return colourList.insert(0, baseColour)
    } else return null
  }
)

export const getArtistTitle = createSelector(
  [getArtistCaseStudies],
  casestudies => {
    const data = casestudies.get('data')
    const collections = data && data.get('collections')

    if (collections) {
      const firstItem = collections.first()

      const acf = firstItem ? firstItem.get('acf') : null
      if (!acf) return null

      const artistNameField = acf && acf.get('artist_name')
      return artistNameField && artistNameField.get('post_title')
    } else return null
  }
)

// Case studies are a list of collections, but only their first row
const getArtistCaseStudyItem = data => {
  if (!data) {
    return null
  }

  const acf = data.get('acf')

  // Check for mobile image and add to result if found
  const isMobileImageSwitch = acf && acf.get('mobile_image_switch')
  const mobileImage = isMobileImageSwitch && acf.getIn(['mobile_image', 'sizes', 'large'])

  return {
    id: data.get('id'),
    slug: data.get('slug'),
    subtitle: data.get('title').get('rendered'),
    title: (acf && acf.get('artist_name')) ? acf.get('artist_name').get('post_title') : '',
    slide: (acf && acf.get('slide')) ? acf.get('slide').first() : null,
    mobileImage: mobileImage
  }
}

export const getArtistCaseStudyFetching = createSelector(
  [getArtistCaseStudies],
  casestudies => casestudies.get('fetching')
)

export const getArtistCaseStudyRequestId = createSelector(
  [getArtistCaseStudies],
  casestudies => casestudies.get('requestId')
)
export const getArtistCaseStudyRows = createSelector(
  [getArtistCaseStudies],
  casestudies => {
    const data = casestudies.get('data')
    if (data && data.get('collections')) {
      return data.get('collections').map(getArtistCaseStudyItem)
    } else {
      return null
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/artist-case-studies-container/selectors.js